import React, { useState } from "react";
import { Form, Input, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { formatToDecimal, limitDecimalInputPrecision } from "../../utils/formaters";

const { Text } = Typography;

const LotNumberFormItem = ({
  dataTMId,
  name,
  editable = true,
  defaultValue,
  onChange,
  allowClear = true,
  placeholder,
  prefix = "",
  minNumberOfDigits = 0,
  maxNumberOfDigits = Number.MAX_VALUE,
  precision = 2,
  rules = [],
  label,
  showLabel = false,
  labelStyle,
  style = [],
  strong = false,
  required = false,
  recordInfo
}) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);

  return (
    <Form.Item
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={
        showLabel ? (
          <Text style={labelStyle} strong={strong}>
            {label}
          </Text>
        ) : null
      }
      style={{ ...style, display: "inline-block" }}
      colon={false}
      validateFirst={true}
      rules={[
        {
          required,
          validateTrigger: "onChange",
          message: t("form.validation.max_not_exceed", { name, maxNumberOfDigits }),
          validator: (_, value) => {
            if (!value || (value?.length >= minNumberOfDigits && value?.length <= maxNumberOfDigits))
              return Promise.resolve();

            return Promise.reject();
          }
        },
        ...rules
      ]}
    >
      {editable ? (
        <Input
          data-tm-id={dataTMId}
          defaultValue={defaultValue}
          allowClear={hover && allowClear}
          prefix={prefix}
          placeholder={placeholder}
          formatter={(e) => formatToDecimal(e.target.value)}
          onKeyDown={(e) => limitDecimalInputPrecision(e, precision)}
          onChange={onChange}
        />
      ) : (
        <Space>
          <Text data-tm-id={dataTMId}>{defaultValue ? `${prefix}${defaultValue}` : "-"}</Text>
        </Space>
      )}
    </Form.Item>
  );
};

export { LotNumberFormItem };
